export const CONTACT_INFO_TRANSLATE_ROOT = 'BOOKING_MODULE.CONTACT_INFO';
